<template>
    <div v-if="addon.isRecommended" class="service-package-recommended">
        <Icon type="ThumbUp" size="s" />
        <span>
            {{
                t({
                    key: 'service_package.recommended',
                    format: LabelFormat.Capitalize,
                })
            }}
        </span>
    </div>

    <h3 class="service-package-title">{{ addon.title }}</h3>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ServicePackage } from '@ui/components/ServicePackage/ServicePackage.interfaces';
    import { t } from '@shared/helpers/translation';
    import { LabelFormat } from '@shared/interfaces/translation';
    import Icon from '../../Icon/Icon.vue';
    import { ServicePackageType } from '@/api/Cart/cart.interfaces';

    export default defineComponent({
        name: 'ServicePackageHeader',
        methods: { t },
        components: {
            Icon,
        },
        props: {
            addon: {
                type: Object as PropType<ServicePackage>,
                required: true,
            },
        },
        setup() {
            return {
                ServicePackageType,
                LabelFormat,
            };
        },
    });
</script>

<style scoped lang="scss">
    @forward '../ServicePackage.scss';
</style>
